module.exports = __webpack_public_path__ + "static/media/option-2.f982bd43.ogg";